import CirclePathTwoTriangles from "@ingka/ssr-icon/paths/circlepath-two-triangles";

export default CirclePathTwoTriangles;
